import React, { useEffect, useRef, useState } from "react";
import { LanguageContext } from "../../Languages/LanguageContext";
import { useContext } from "react";
import { getProfile } from "../../../features/profile/profileSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { logout } from "../../../features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { editProfile } from "../../../features/profile/profileSlice";
import toast from "react-hot-toast";
import OtpModal from "../../auth/OTPModal";

const EditProfile = () => {
  const { t } = useContext(LanguageContext);
  const { profileData, loading, error } = useSelector((state) => state.profile);
  const role = useSelector((state) => state.auth?.user?.role);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    role: "",
    phone: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [image, setImage] = useState(null);
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profileData) {
      setFormData({
        name: profileData.name || "",
        email: profileData.email || "",
        role: profileData.role_name || "",
        phone: profileData.phone || "",
      });
      setImage(profileData.image || "");
    }
  }, [profileData]);

  const handleIconClick = () => fileInputRef.current.click();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setImage(URL.createObjectURL(file));
  };

 const handleEditToggle = async () => {
  if (isEditing) {
    let hasError = false;
    const newErrors = { name: "" };

    const trimmedName = formData.name.trim();

    if (!trimmedName) {
      newErrors.name = "Username is required";
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    const payload = {
      name: trimmedName,
    };

    const result = await dispatch(editProfile(payload));


    //  API success
    if (editProfile.fulfilled.match(result)) {
      toast.success("Profile updated successfully");
      dispatch(getProfile());
      setIsEditing(false); // exit edit mode
      return;
    }
  }

  setIsEditing(!isEditing);
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value.trimStart() });
  };
  // const handleOtpSubmit = async () => {
  //   if (!otp) {
  //     setOtpError("Please enter the OTP");
  //     return;
  //   }

  //   const result = await dispatch(verifyEmailChange(otp));

  //   if (verifyEmailChange.fulfilled.match(result)) {
  //     toast.success(result.payload?.message || "Email verified successfully!");
  //     setShowOtpModal(false);
  //     setOtp("");
  //     setOtpError("");
  //     dispatch(getProfile());
  //     toast.success("Profile updated successfully!");
  //   } else {
  //     setOtpError(result.payload?.message || "Invalid OTP, please try again");
  //     toast.error(result.payload?.message || "Invalid OTP");
  //   }
  // };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    window.location.reload();
  };
  const handleDelete = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete your account?",
    );

    if (!confirmDelete) return;

    navigate("/account-deletion");
  };

  const firstLetter = formData.name
    ? formData.name.charAt(0).toUpperCase()
    : "?";

  return (
    <div className="container ">
      <h4 className="text-light mb-3">{t.profile}</h4>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow">
            {/* Header Section */}
            <div
              className="bg-danger text-white p-4 d-flex align-items-center"
              style={{ height: role === "partner" ? "200px" : "auto" }}
            >
              {/* Avatar */}
              <div className="position-relative me-3">
                {image ? (
                  <img
                    src={image}
                    alt="Profile"
                    className="rounded-circle border border-white shadow"
                    style={{
                      width: role === "partner" ? "120px" : "90px",
                      height: role === "partner" ? "120px" : "90px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    className="rounded-circle bg-light d-flex align-items-center justify-content-center text-danger fw-bold border border-white shadow"
                    style={{
                      width: role === "partner" ? "120px" : "90px",
                      height: role === "partner" ? "120px" : "90px",
                      fontSize: "36px",
                    }}
                  >
                    {firstLetter}
                  </div>
                )}
                {/* <div
                  onClick={handleIconClick}
                  className="rounded-circle d-flex justify-content-center align-items-center bg-secondary position-absolute"
                  style={{
                    width: "28px",
                    height: "28px",
                    bottom: "0",
                    right: "0",
                    cursor: "pointer",
                  }}
                >
                  <i
                    className="bi bi-pencil text-dark"
                    style={{ fontSize: "14px" }}
                  ></i>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                </div> */}
              </div>

              {/* User Info beside avatar */}
              <div>
                <h5 className="mb-1 text-capitalize">{formData.name}</h5>
                <p className="mb-1 small">{formData.email}</p>
                <p className="mb-0 small">{formData.phone}</p>
              </div>
            </div>

            {/* Body Section */}
            {role && role !== "partner" && (
              <div className="card-body">
                <form className="px-4">
                  <div className="row mb-2">
                    <div className="col-md-6 mb-2">
                      <label className="form-label fw-bold">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={(e) => {
                          handleChange(e);
                          setErrors({ ...errors, name: "" });
                        }}
                        disabled={!isEditing}
                        style={{
                          borderColor: "#3f5263",
                          outline: "none",
                          boxShadow: "none",
                        }}
                      />
                      {errors.name && (
                        <div className=" small mt-1" style={{ color: "red" }}>
                          {errors.name}
                        </div>
                      )}
                    </div>

                    <div className="col-md-6 mb-2">
                      <label className="form-label fw-bold">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={(e) => {
                          handleChange(e);
                          setErrors({ ...errors, email: "" });
                        }}
                          disabled
                        style={{
                          borderColor: "#3f5263",
                          outline: "none",
                          boxShadow: "none",
                        }}
                      />
                      {errors.email && (
                        <div className=" small mt-1" style={{ color: "red" }}>
                          {errors.email}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6 mb-2">
                      <label className="form-label fw-bold">Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        name="phone"
                        value={formData.phone}
                        onChange={(e) => {
                          handleChange(e);
                          setErrors({ ...errors, phone: "" });
                        }}
                         disabled
                        style={{
                          borderColor: "#3f5263",
                          outline: "none",
                          boxShadow: "none",
                        }}
                      />
                      {errors.phone && (
                        <div className=" small mt-1" style={{ color: "red" }}>
                          {errors.phone}
                        </div>
                      )}
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold">Role</label>
                      <input
                        type="text"
                        className="form-control"
                        name="role"
                        value={formData.role}
                        disabled
                        style={{
                          borderColor: "#3f5263",
                          outline: "none",
                          boxShadow: "none",
                        }}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mt-4">
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-light text-info "
                        onClick={handleEditToggle}
                      >
                        <i className="bi bi-pencil me-2 text-info"></i>
                        {isEditing ? "Update" : "Edit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-light text-info "
                        onClick={handleDelete}
                      >
                        <i className="bi bi-trash me-2 text-info"></i>
                        Delete
                      </button>
                    </div>

                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={handleLogout}
                    >
                      <i className="bi bi-box-arrow-right me-2"></i> Logout
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* {showOtpModal && (
        <OtpModal
          otp={otp}
          setOtp={setOtp}
          onSubmit={handleOtpSubmit}
          onClose={() => setShowOtpModal(false)}
          otpError={otpError}
          setOtpError={setOtpError}
          title="Enter OTP to verify email"
        />
      )} */}
    </div>
  );
};

export default EditProfile;
